/** @format */

// Exemple de composant React dans le frontend client
/*
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import jwt_decode from "jwt-decode";
import { useLocation, useNavigate } from "react-router-dom";
import { customer_login } from "../store/reducers/authReducer";

const SwitchLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      try {
        const decoded = jwt_decode(token);
        dispatch(customer_login({
          token,
          id: decoded.id,
          name: decoded.name,
          email: decoded.email,
          method: decoded.method,
        }));
        navigate("/"); // vers la home du client
      } catch (err) {
        console.error("Token invalide", err);
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }, [location.search, dispatch, navigate]);

  return null;
};

export default SwitchLogin;
*/

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setCustomerData } from "../store/reducers/authReducer";

const UseLoadCustomerFromCookie = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  //const params = new URLSearchParams(location.search);
  /*
  useEffect(() => {
    //const customerToken = Cookies.get("customerToken");
    const params = new URLSearchParams(location.search);
    const customerToken = params.get("token");

    if (customerToken) {
      dispatch(setCustomerData({ token: customerToken }));
      // Optionnel : rediriger vers la page client une fois le token chargé
  
      navigate("/dashboard", { replace: true });

    }
  }, [dispatch, navigate, location]);*/

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const customerToken = params.get("token");
    const fromRole = params.get("from"); // ex: "seller"

    //console.log('params', params)

    if (customerToken) {
      dispatch(setCustomerData({ token: customerToken }));

      // Après avoir stocké le token client, logout du rôle précédent
      if (fromRole === "seller") {
        // Appel à l'API du frontend vendeur pour logout
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/seller/logout`, {
          method: "GET",
          credentials: "include", // pour les cookies httpOnly
        })
          .then(() => {
            // Redirige vers le dashboard client après cleanup
            navigate("/dashboard");
          })
          .catch(() => {
            // Même en cas d'erreur, on continue
            navigate("/dashboard");
          });
      } else {
        navigate("/dashboard");
        //alert('else error')
      }
    }
  }, [dispatch, location, navigate]);
};

export default UseLoadCustomerFromCookie;

/*
import Cookies from "js-cookie"; // Assure-toi d'avoir installé `js-cookie`
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCustomerData } from "../store/reducers/authReducer";

const UseLoadCustomerFromCookie = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const customerToken = Cookies.get("customerToken");

    if (customerToken) {
      dispatch(setCustomerData({ token: customerToken }));
      navigate("/dashboard", { replace: true });
    }
  }, [dispatch, navigate]);
};

export default UseLoadCustomerFromCookie;
*/
